export default __webpack_public_path__ + "static/media/gtranslate-mobile-2.64149b18.png";